import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { Options } from "ng5-slider";
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie';
import { AdditionalDocService } from '../Services/additional-doc.service';
import { CardServiceService } from '../Services/card-service.service';

@Component({
  selector: "app-card-upload-document",
  templateUrl: "./card-upload-document.component.html",
  standalone:false,
  styleUrls: ["./card-upload-document.component.scss"],
})
export class CardUploadDocumentComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  options: Options;
  value: number = 0;
  otp: string = "";
  DocConfig: any;
  docs = [];
  name: any;
  DocsName = [];
  DocList = [];
  imageId: any;
  SaveDocRes: any;

  constructor(private _router: Router, private addoc: AdditionalDocService,public cardService:CardServiceService, private location: Location, private common: CommonService, public auth: AuthService, private cookieService: CookieService) { }

  async ngOnInit(): Promise<any> {


    this.auth.accessToken = await this.common.Get("token");
    let a =await this.cookieService.get("AutoTempLimitObj",true);
    if(a){
      this.cardService.AutoTempLimitObj = JSON.parse(a);
    }

    this.DocList = [];
    this.common.presentLoading();
    this.addoc.GetDocConfigFLow(0, this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {
        this.common.hideLoading();
        this.DocConfig = [...res.response.content];

        this.DocConfig.forEach(element => {

          element.listofadddoc.forEach(e => {
            this.docs.push(e)

          })
        });
        console.log("docs", this.docs);


        // this.DocsName = this.docs.map(x=>({Name:x.labelEn}))
        this.docs.forEach(x => {

          this.DocsName.push(x.labelEn);

        })
        console.log("DocsName", this.DocsName);
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert("", "OK", this._router, res);
      }
    })



    this.options = {
      floor: 0,
      ceil: 100,
      enforceRange: false,
    };


  }

  back() {
    this.location.back();
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  cardUploadDocument() {
    this._router.navigateByUrl("/CardUploadDocument");
  }


  onOtpChange(e) {
    if (e.length == 4) {
      this.otp = e.toString();
    } else {
      this.otp = null;
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {
    }
  }

  cardLimitSuccess() {
    this._router.navigateByUrl("/CardLimitSuccess");
  }

  async Uploaddoc(event, d, i) {

    console.log('event', event);

    this.name = event[0];
    this.docs[i]['name'] = this.name

    console.log("docs", this.docs);

    let type = event[1].split('/');


    let body = {
      Id: d.docId,
      type: type[1],
      image: event[2],
    };
    this.common.presentLoading();
    await this.auth.SaveTempImage(this.auth.accessToken, body).then(async (data: any) => {
      if (data?.response?.code == 1) {

        this.imageId = data?.response?.content?.id;
        if (this.DocList.length > 0) {

          this.DocList.forEach(x => {

            if (x.DocId == d.docId) {

              x.ImageId.push(this.imageId);
              console.log('.DocList', this.DocList)


            }
            else{
              let D = this.DocList.filter(x=> d.docId == x.DocId);

              if(D.length == 0){

                let ImageId = [];
                ImageId.push(this.imageId);
      
                this.DocList.push({ DocId: d.docId.toString(), ImageId: ImageId });

                console.log('.DocList', this.DocList)

              }
            }
          })
          

        }
        else {

          let ImageId = [];
          ImageId.push(this.imageId);

          this.DocList.push({ DocId: d.docId.toString(), ImageId: ImageId });
          console.log('.DocList', this.DocList)

        }

        await this.common.hideLoading();

        console.log("SaveTempImage", data);
      }
      else {
        await this.common.hideLoading();
        this.common.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  SaveLimitDoocs() {

    let body={
      limitType: "TEMPLIMIT",
      LimitRequestId: this.cardService.AutoTempLimitObj.limitRequestId,
      DocList:this.DocList
    }
    this.common.presentLoading();
    this.addoc.SaveLimitDoc(body,this.auth.accessToken).then((res:any)=>{
      if(res?.response?.code == 1){
        this.SaveDocRes = res.response.content;
        console.log("SaveDocRes",this.SaveDocRes);
        this.auth.LimitSendEmailOTP(this.auth.accessToken).then((data:any)=>{

          if(data?.response?.code ==1){
            this.common.hideLoading();
          this._router.navigateByUrl("/EnterPin");

          }
          else{
            this.common.hideLoading();
            this.common.ParseErrorAlert("","OK",this._router,res);
          }
        })
        
      }
      else{
        this.common.hideLoading();
        this.common.ParseErrorAlert("","OK",this._router,res);
      }
    })
  }

  // this.supportP.uploaddoc.push({
  //   docHeading: heading,
  //   docId: event[4],
  //   documentType: event[3],
  //   base64: event[1],
  //   willSubmitLater: this.upload,
  //   skipped: this.skipped,
  // })

  // console.log('this.supportP.uploaddoc', this.supportP.uploaddoc)
}

